import Schema from 'AppReact/schema';

export default {
  disabled: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  focused: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  maxLength: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  placeholder: Schema('string', 'primitive-nullable', { defaultValue: null }),
  label: Schema('string', 'primitive-nullable', { defaultValue: null }),
  value: Schema('string', 'primitive-nullable', { defaultValue: null }),
  focused: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  error: Schema('string', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  tagInputRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
}
